import React from "react";
import { useAssetsGetModel } from "../assetsGetModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsGetModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "领取单号",
            fieldName: "code",
            span:4
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "领取人",
            fieldName: "user",
            span:4
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "领取部门",
            fieldName: "department",
            span:4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "存放地点",
            fieldName: "deposit",
            span:4
        },  {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["领取起始日期", "领取结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
            span:4
        }, 
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}